export const isSingleParam = (message) => !!(message.logName || message.eventName || message.callback);
//# sourceMappingURL=isSingleParam.js.map